import moment from 'moment';

/**
 * The instant a day's question resolves at.
 *
 * The engine answers "the latest version computed at or before this instant"
 * (ADR-016 decision 2), so asking at the *start* of a day would miss a version
 * computed during it. The end of the day is what "in force on this date" means.
 *
 * UTC throughout: the catalogue's instants are UTC, so a viewer's timezone must
 * not change which version they are shown.
 */
export const endOfUtcDay = (day: string): string => moment.utc(day, 'YYYY-MM-DD').endOf('day').toISOString();

/** The UTC day an instant falls in — what a date input should show for it. */
export const utcDayOf = (at: Date): string => moment.utc(at).format('YYYY-MM-DD');
